import { config } from "../config";
import { getBaseHeaders, handleApiError } from "./utils";
import { setUserId } from "./validation";
import { normalizeEmail } from "@/utils/emailUtils";
import { LoginResponse, UserLogin } from "@/types/auth";
import { tokenManager } from "./tokenManager";
import { isNative } from "@/utils/platform";
import { nativeTokenStore } from "./nativeTokenStore";

const getGeolocation = async (): Promise<{ latitude: number; longitude: number } | null> => {
  return null;
};

const getDeviceInfo = () => {
  return {
    screen_resolution: `${window.screen.width}x${window.screen.height}`,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    language: navigator.language,
  };
};

export const login = async (credentials: { email: string; password: string }): Promise<LoginResponse> => {
  try {
    const location = await getGeolocation();
    const device_info = getDeviceInfo();

    const requestBody: UserLogin = {
      ...credentials,
      email: normalizeEmail(credentials.email),
      location: location || undefined,
      device_info,
    };

    const fetchInit: RequestInit = {
      method: 'POST',
      headers: getBaseHeaders(),
      body: JSON.stringify(requestBody),
    };

    if (!isNative()) {
      fetchInit.credentials = 'include';
    }

    const response = await fetch(`${config.API_URL}/user/login`, fetchInit);

    if (!response.ok) {
      await handleApiError(response, 'Login');
    }

    const loginData: LoginResponse = await response.json();

    if (loginData.user_id) {
      setUserId(loginData.user_id);
      tokenManager.resetRefreshFailed();
    }

    if (isNative() && loginData.access_token && loginData.refresh_token) {
      try {
        await nativeTokenStore.save({
          access_token: loginData.access_token,
          refresh_token: loginData.refresh_token,
          user_id: loginData.user_id,
        });
      } catch (e) {
        console.warn('Failed to persist native tokens after login', e);
      }
    }

    return loginData;
  } catch (error) {
    throw error;
  }
};
